import { render, staticRenderFns } from "./AppStore.vue?vue&type=template&id=60d800b8"
import script from "./AppStore.vue?vue&type=script&lang=js"
export * from "./AppStore.vue?vue&type=script&lang=js"
import style0 from "./AppStore.vue?vue&type=style&index=0&id=60d800b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports